import { useGlobalSearchParams, useNavigation } from 'expo-router';
import { useEffect } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';
import Animated, { useAnimatedRef } from 'react-native-reanimated';

import { useGetPrograms } from '@/api/hooks/programHooks';
import { Program } from '@/api/models/programModels';
import DotsLoader from '@/components/DotsLoader';
import ListEmptyComponent from '@/components/ListEmptyComponent';
import { useScrollProps } from '@/components/navigation/TopTabsReanimated';
import ProgramCard from '@/components/program/ProgramCard';
import { i18n } from '@/utils/i18n';

const Programs = () => {
  const { npoId } = useGlobalSearchParams<{
    npoId: string;
    name: string;
  }>();

  const { data: programsResponse, isPending } = useGetPrograms({ nonProfitOrgId: npoId });
  const navigation = useNavigation<any>();
  const { scrollEnabled, scrollTopHeader, scrollHandler } = useScrollProps();

  const programs = programsResponse?.data.flatMap((program) => program);

  const flatRef = useAnimatedRef<Animated.FlatList<any>>();
  const renderDivider = () => <Divider style={style.divider} />;

  useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', () => {
      scrollTopHeader();
      flatRef.current?.scrollToOffset({
        offset: 0,
        animated: false
      });
    });

    return unsubscribe;
  }, [flatRef, navigation, scrollTopHeader]);

  return (
    <View style={style.container}>
      {isPending ? (
        <DotsLoader />
      ) : (
        <Animated.FlatList
          ref={flatRef}
          data={programs}
          onScroll={scrollHandler}
          style={style.fullWidth}
          scrollEnabled={scrollEnabled}
          showsVerticalScrollIndicator={false}
          bounces={false}
          contentContainerStyle={style.listContentContainer}
          keyExtractor={(item: Program) => item.id}
          ItemSeparatorComponent={() => renderDivider()}
          renderItem={({ item }: { item: Program }) => (
            <ProgramCard
              canEdit={false}
              program={item}
              // onCardPress={() => {
              //   router.navigate({
              //     pathname: '/programDetail/[programId]',
              //     params: {
              //       programId: item.id,
              //       npoId: npoId,
              //       npoName: npoName,
              //       programJson: JSON.stringify(item)
              //     }
              //   });
              // }}
            />
          )}
          ListEmptyComponent={<ListEmptyComponent label={i18n.t('npo_tab.empty_programs')} />}
        />
      )}
    </View>
  );
};

export default Programs;

const style = StyleSheet.create({
  container: {
    paddingHorizontal: Platform.OS !== 'web' ? 18 : 0,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  divider: {
    marginVertical: 25
  },

  fullWidth: {
    width: '100%'
  },

  listContentContainer: {
    gap: 25,
    paddingBottom: 35
  }
});
